export default __webpack_public_path__ + "static/media/yesartworkshome.a725a3c3.png";